import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CardHeader from "@mui/material/CardHeader";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CardMedia from "@mui/material/CardMedia";
import CardActions from "@mui/material/CardActions";
import TouchAppIcon from '@mui/icons-material/TouchApp';
import Card from "@mui/material/Card";

import {Templates} from "../components/Templates";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Stack from "@mui/material/Stack";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {Select} from "@mui/material";
import {isMobile} from "is-mobile";

const API_BASE = window.location.hostname;

export default function Themes() {

    const mobile = isMobile();

    const [previewOpen, setPreviewOpen] = useState(false);

    const [previewUrl, setPreviewUrl] = useState(null);

    const [iframeKey, setIframeKey] = useState(0);

    const [color, setColor] = useState('');

    const [template, setTemplate] = useState(null);

    const history = useHistory();

    const handleUseTemplate = (name, colorScheme) => {

        history.push(`/form?template=${name}&color=${colorScheme}`);

    }

    const handlePreviewOpen = (name, colorScheme) => {

        setTemplate(name);

        setColor(colorScheme);

        const url = API_BASE === 'localhost' ? `/demo.html?template=${name}&color=${colorScheme}` : `/form_editor/demo.html?template=${name}&color=${colorScheme}`;

        setPreviewUrl(url);

        setPreviewOpen(true);

    };

    const handlePreviewClose = () => {

        setPreviewOpen(false);

        setTemplate(null);

    };

    const handleColorChange = (e) => {

        const newColor = e.target.value;

        setColor(newColor);

        const url = API_BASE === 'localhost' ? `/demo.html?template=${template}&color=${newColor}` : `/form_editor/demo.html?template=${template}&color=${newColor}`;

        setPreviewUrl(url);

        // reload iframe
        setIframeKey(iframeKey + 1);

        console.log('handleColorChange', e.target.value);

    }

    return <>

        <Typography className="mt-48" typography={mobile ? 'h4' : 'h2'} textAlign="center">Choose Template</Typography>

        <Stack
            className="mt-50 pb-48 text-center"
            spacing={2}
            justifyContent="center"
            direction="row">
            <Button variant="outlined"
                    size="large"
                    onClick={e => {

                        e.preventDefault();

                        history.push('/');

                    }}
                    startIcon={<ArrowBackIcon />}>
                Back to Home
            </Button>
        </Stack>

        <Grid container spacing={3} sx={{ mt: 0, mb: 4 }} className="flex flex-wrap w-full justify-center p-16 mb-90" style={{maxWidth: 1200, margin: !mobile && '0 auto'}}>

            {Templates.map((item, index) =>
                <Grid key={`card-${index}`} item xs={12} lg={3}>
                    <Card sx={{width: '100%', height: '100%'}} className="mb-24 pb-0 rounded-16">
                        <CardHeader
                            title={item.title}
                            className="text-center"
                            style={{cursor: 'pointer'}}
                            onClick={() => handleUseTemplate(item.name, item.colorScheme)}
                        />
                        <CardMedia
                            component="img"
                            height={360}
                            style={{cursor: 'pointer', objectFit: 'contain', backgroundSize: 'contain'}}
                            image={item.image}
                            alt="Form"
                            onClick={() => handleUseTemplate(item.name, item.colorScheme)}
                        />
                        <CardActions style={{display: 'flex', justifyContent: 'space-between'}}>
                            <Tooltip title="Preview">
                                <IconButton aria-label="Preview" onClick={() => handlePreviewOpen(item.name, item.colorScheme)}>
                                    <VisibilityIcon/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Use Theme">
                                <IconButton aria-label="Use Theme" onClick={() => handleUseTemplate(item.name, item.colorScheme)}>
                                    <TouchAppIcon/>
                                </IconButton>
                            </Tooltip>
                        </CardActions>
                    </Card>
                </Grid>
            )}

        </Grid>

        <Stack
            className="mt-50 pb-48 text-center"
            spacing={2}
            justifyContent="center"
            direction="row">
            <Button variant="outlined"
                    size="large"
                    onClick={e => {

                        e.preventDefault();

                        history.push('/');

                    }}
                    startIcon={<ArrowBackIcon />}>
                Back to Home
            </Button>
        </Stack>

        <Dialog open={previewOpen} onClose={handlePreviewClose} maxWidth="xl" fullWidth={true}>
            <DialogTitle align="center">Form Preview</DialogTitle>
            <DialogContent dividers>
                <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                    <InputLabel id={`formColorSchemeLabel`}>Color Scheme</InputLabel>
                    <Select
                        key={`confFormColorSchemeLabel`}
                        name="formColorScheme"
                        id="formColorScheme"
                        defaultValue={color}
                        label="Color Scheme"
                        onChange={e => handleColorChange(e)}>
                        <MenuItem value="default">Default</MenuItem>
                        <MenuItem value="dark">Dark</MenuItem>
                        <MenuItem value="blue">Blue</MenuItem>
                        <MenuItem value="azure">Azure</MenuItem>
                        <MenuItem value="orange">Orange</MenuItem>
                        <MenuItem value="brown">Brown</MenuItem>
                        <MenuItem value="lime">Lime</MenuItem>
                        <MenuItem value="green">Green</MenuItem>
                        <MenuItem value="violet">Violet</MenuItem>
                        <MenuItem value="pink">Pink</MenuItem>
                        <MenuItem value="red">Red</MenuItem>
                        <MenuItem value="white">White</MenuItem>
                    </Select>
                </FormControl>
                <iframe  title="Your form preview" src={previewUrl} width="100%" height="640px" frameBorder="none"></iframe>
            </DialogContent>
            <DialogActions>
                <Button onClick={e => handleUseTemplate(template, color)}>Use This Template</Button>
                <Button onClick={handlePreviewClose}>Close</Button>
            </DialogActions>
        </Dialog>

    </>;
}